import { Easing, withDelay, withRepeat, withSequence, withTiming } from 'react-native-reanimated';

export const AUTOPLAY_CARD_DURATION = 5200;
export const AUTOPLAY_ROUND_PAUSE = 2000;

export function autoplayCarouselFrom(
  start: number,
  count: number,
  {
    cardDuration = AUTOPLAY_CARD_DURATION,
    roundPause = AUTOPLAY_ROUND_PAUSE,
  }: { cardDuration?: number; roundPause?: number } = {},
) {
  'worklet';
  // Ease the full revolution so it accelerates away from rest and decelerates
  // back into the starting arrangement. The identical end pose can then hold
  // before the next revolution begins without a visual reset.
  return withRepeat(
    withSequence(
      withTiming(start + count, {
        duration: cardDuration * count,
        easing: Easing.bezier(0.42, 0, 0.58, 1),
      }),
      withDelay(roundPause, withTiming(start + count, { duration: 0 })),
    ),
    -1,
    false,
  );
}
